import { useCallback, useEffect, useState } from "react";
import { v1Contract } from "config";
import { useContract, useProvider } from "wagmi";
import { BigNumber } from "ethers";

const useV1sInWallet = (
  address?: string
): [tokenIds: number[] | undefined, readNftsInWallet: () => void] => {
  const [tokenIds, setTokenIds] = useState<number[]>();
  const provider = useProvider();
  const contract = useContract({
    addressOrName: v1Contract.address,
    contractInterface: v1Contract.interface,
    signerOrProvider: provider,
  });

  const readNftsInWallet = useCallback(async () => {
    if (!contract || !address) {
      return;
    }

    try {
      const tokens: number[] = [];
      const balance: number = (
        (await contract.balanceOf(address)) as BigNumber
      ).toNumber();
      if (balance === 0) {
        setTokenIds([]);
        return;
      }

      for (let i = 0; i < balance; i++) {
        const tokenId: BigNumber = await contract.tokenOfOwnerByIndex(
          address,
          i
        );
        tokens.push(tokenId.toNumber());
      }

      setTokenIds(tokens);
    } catch (err) {}
  }, [address, contract]);

  useEffect(() => {
    readNftsInWallet();
  }, [readNftsInWallet]);

  return [tokenIds, readNftsInWallet];
};

export default useV1sInWallet;
